import { IPageTitleProps } from './types'
import { PageTitleWrapper } from './styles'
import React from 'react'

function PageTitle({ children, className }: IPageTitleProps) {
	return <PageTitleWrapper className={className}>{children}</PageTitleWrapper>
}

export default PageTitle
